// Content-derived React keys; repeated content gets a #n suffix so keys stay unique and stable.
export const contentKeys = (items, fn) => {
  const seen = {};
  return items.map((it) => {
    const base = fn(it);
    seen[base] = (seen[base] || 0) + 1;
    return seen[base] > 1 ? `${base}#${seen[base]}` : base;
  });
};
